module.exports = __webpack_public_path__ + "img/item-2.b7ffc04.png";